import { render, staticRenderFns } from "./VerifyOtpForm.vue?vue&type=template&id=45dedd52&"
import script from "./VerifyOtpForm.vue?vue&type=script&lang=js&"
export * from "./VerifyOtpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports